if (!customElements.get('td-product-cards')) {
  class TDProductCards extends HTMLElement {
    static selectors = {
      grid: '[data-td-product-cards-grid]',
      card: '[data-td-product-card]',
      details: '[data-td-product-card-details]',
    };

    constructor() {
      super();
      this.handleCardPointerOver = this.handleCardPointerOver.bind(this);
      this.handleCardFocusIn = this.handleCardFocusIn.bind(this);
      this.handleGridRelease = this.handleGridRelease.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.grid = this.querySelector(TDProductCards.selectors.grid);
      this.lastViewportWidth = window.innerWidth;

      this.grid?.addEventListener('pointerover', this.handleCardPointerOver);
      this.grid?.addEventListener('focusin', this.handleCardFocusIn);
      this.grid?.addEventListener('mouseleave', this.handleGridRelease);
      this.grid?.addEventListener('focusout', this.handleGridRelease);
      window.addEventListener('resize', this.handleResize, { passive: true });

      this.measureDetailsZones();
      document.fonts?.ready?.then(() => {
        if (this.isConnected) {
          this.measureDetailsZones();
        }
      });
    }

    disconnectedCallback() {
      this.grid?.removeEventListener('pointerover', this.handleCardPointerOver);
      this.grid?.removeEventListener('focusin', this.handleCardFocusIn);
      this.grid?.removeEventListener('mouseleave', this.handleGridRelease);
      this.grid?.removeEventListener('focusout', this.handleGridRelease);
      window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
      if (window.innerWidth === this.lastViewportWidth) {
        return;
      }

      this.lastViewportWidth = window.innerWidth;
      this.measureDetailsZones();
    }

    measureDetailsZones() {
      this.getCards().forEach((card) => {
        const details = card.querySelector(TDProductCards.selectors.details);
        if (details) {
          card.style.setProperty('--td-product-card-details-height', `${details.offsetHeight}px`);
        }
      });
    }

    handleCardPointerOver(event) {
      if (!(event.target instanceof Element)) {
        return;
      }

      const card = event.target.closest(TDProductCards.selectors.card);
      if (!card || !this.grid.contains(card)) {
        return;
      }

      if (event.relatedTarget instanceof Node && card.contains(event.relatedTarget)) {
        return;
      }

      this.setActiveCard(card.dataset.tdCardIndex);
    }

    handleCardFocusIn(event) {
      if (!(event.target instanceof Element)) {
        return;
      }

      const card = event.target.closest(TDProductCards.selectors.card);
      if (card && this.grid.contains(card)) {
        this.setActiveCard(card.dataset.tdCardIndex);
      }
    }

    handleGridRelease(event) {
      if (event.type === 'focusout' && this.grid.contains(event.relatedTarget)) {
        return;
      }

      this.setActiveCard(null);
    }

    setActiveCard(cardIndex) {
      this.getCards().forEach((card) => {
        card.dataset.tdActive = card.dataset.tdCardIndex === cardIndex ? 'true' : 'false';
      });
    }

    getCards() {
      return this.grid ? Array.from(this.grid.querySelectorAll(TDProductCards.selectors.card)) : [];
    }
  }

  customElements.define('td-product-cards', TDProductCards);
}
